import { useStore } from '../context/StoreContext';
import { Icon } from '../shared/ui/Icon';
import { formatPrice, getProductPrice, safeImage, categoryName } from '../entities/product/helpers';

export function CartPage() {
  const {
    cartCount, cartItems, subtotal,
    go, browseCategory, openProduct, updateCart, removeFromCart,
  } = useStore();

  return (
    <section className="flow-page">
      <div className="breadcrumb">
        <button onClick={() => go('home')}>Home</button>
        <i>/</i>
        <span>Your bag</span>
      </div>

      <div className="flow-heading">
        <div>
          <p className="eyebrow">YOUR SELECTION</p>
          <h1>Your Cart <span>({cartCount})</span></h1>
        </div>
        <button className="text-link" onClick={() => browseCategory()}>
          Continue shopping <Icon>↗</Icon>
        </button>
      </div>

      {cartItems.length ? (
        <div className="cart-layout">
          <div className="cart-lines">
            {cartItems.map((item) => (
              <article className="cart-line" key={item.id}>
                <button className="cart-line-image" onClick={() => openProduct(item.product)}>
                  <img src={safeImage(item.product)} alt={item.product.title || item.product.name} />
                </button>
                <div className="cart-line-copy">
                  <span className="eyebrow">{item.product.brand || categoryName(item.product.category)}</span>
                  <button onClick={() => openProduct(item.product)}>
                    {item.product.title || item.product.name}
                  </button>
                  <span>{formatPrice(getProductPrice(item.product))}</span>
                  <div className="quantity-control">
                    <button aria-label="Decrease quantity" onClick={() => updateCart(item, item.qty - 1)}>−</button>
                    <span>{item.qty}</span>
                    <button aria-label="Increase quantity" onClick={() => updateCart(item, item.qty + 1)}>＋</button>
                  </div>
                </div>
                <div className="cart-line-total">
                  <b>{formatPrice(getProductPrice(item.product) * item.qty)}</b>
                  <button className="remove-item" aria-label="Remove item" title="Remove item" onClick={() => removeFromCart(item)}>
                    <Icon>trash</Icon>
                  </button>
                </div>
              </article>
            ))}
          </div>
          <aside className="order-summary">
            <p className="eyebrow">ORDER SUMMARY</p>
            <h2>Your order</h2>
            <div><span>Subtotal</span><b>{formatPrice(subtotal)}</b></div>
            <div><span>Shipping</span><b className="shipping-value">Calculated at checkout</b></div>
            <div className="summary-total"><span>Total</span><strong>{formatPrice(subtotal)}</strong></div>
            <button className="button button-primary full-width" onClick={() => go('checkout')}>
              Proceed to Checkout <Icon>→</Icon>
            </button>
            <p className="secure-note">Secure checkout · Flexible payment options</p>
          </aside>
        </div>
      ) : (
        <div className="empty-state cart-empty">
          <span className="empty-icon"><Icon>bag</Icon></span>
          <h2>Your bag is taking a breather.</h2>
          <p>Find something you love and it will be right here.</p>
          <button className="button button-primary" onClick={() => browseCategory()}>
            Explore the collection <Icon>↗</Icon>
          </button>
        </div>
      )}
    </section>
  );
}
